import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
} from "@mui/material";

export default function UserInfo() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/users`);
        const data = await response.json();

        const formatted = data.map((user) => ({
          name: user.name,
          email: user.email,
          number: user.number,
          role: user.message,
        }));

        setMessages(formatted);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchMessages();
  }, []);

  return (
    <Container sx={{ py: 2 }}>
      <Typography
        variant="h3"
        fontWeight="bold"
        color="black"
        textAlign="center"
        gutterBottom
      >
        USER INFO
      </Typography>
      <Box mt={10} />

      <Grid container spacing={3}>
        {messages.length === 0 ? (
          <Typography variant="body1" textAlign="center" width="100%">
            No users found.
          </Typography>
        ) : (
          messages.map((user, index) => (
            <Grid item xs={12} key={index}>
              <Card sx={{ boxShadow: 3, borderRadius: 2 }}>
                <CardContent>
                  <Typography variant="h6" color="primary" gutterBottom>
                    {user.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    📧 {user.email}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    📞 {user.number}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
}
